// extracted by mini-css-extract-plugin
module.exports = {"Upload":"index_Upload__2lErJ","uploadIconWrapper":"index_uploadIconWrapper__2WevG","uploadIconText":"index_uploadIconText__6tv1G","uploadImg":"index_uploadImg__1Dt9G"};